var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        needHelp: false,
        breadcrumbs: ["Home", "Refer A Friend"],
      },
    },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c(
                    "FormTitle",
                    {
                      staticClass: "pa-4 pb-0",
                      attrs: { dark: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "subtitle",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "text-lg" }, [
                                _c("u", [
                                  _vm._v("Now here’s the special gift"),
                                ]),
                                _vm._v(
                                  ": If you could\n                            give someone a month of lessons at Musicologie\n                            without it costing you anything, would you?\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-lg" }, [
                                _vm._v(
                                  "\n                            Here’s your chance! If you know someone who\n                            would benefit from music lessons, we’d love to\n                            give them\n                            "
                                ),
                                _c("u", [_vm._v("a free month of lessons")]),
                                _vm._v(
                                  ". Just enter their\n                            info below and we’ll hook them up!\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              false
                                ? _c("div", { staticClass: "text-lg" }, [
                                    _vm._v(
                                      "\n                            These lessons for your friend come with no\n                            strings attached. We just want to say thanks to\n                            you, and to share Musicologie with someone who\n                            might benefit.\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [_vm._v("Thank you!")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "pa-0", attrs: { cols: "12", sm: "6" } },
                [
                  _c("StudentSurveyReferral", {
                    attrs: { errors: _vm.errors, surveyID: _vm.surveyID },
                    on: {
                      success: function ($event) {
                        _vm.$refs.layout.showMessage = true
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }